import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { i18n } from '../App';
import Button from './Button';

export default function CoolfooderFirstname() {
  const [globalState, globalDispatch] = useCoolfoodContext();
  const [firstname, setFirstname] = useState(globalState.coolfooder.firstname);
  const [buttonActive, setButtonActive] = useState(false);

  useEffect(() => {
    setButtonActive(firstname.length > 0 ? true : false);
  }, [firstname]);

  const saveFirstname = (e) => {
    globalDispatch({
      type: actions.SET_COOLFOODER_INFOS,
      infos: { firstname }
    });
  }

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={12} sm={4}>
        <TextField
          id="firstname"
          label={i18n._('Votre prénom')}
          fullWidth
          onChange={e => setFirstname(e.target.value)}
          defaultValue={globalState.coolfooder.firstname}
          variant="outlined"
          margin="dense"
          disabled={window._firstname}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Button
          type="submit"
          id="firstnameSubmit"
          disabled={!buttonActive || window._firstname}
          color="primary"
          variant="contained"
          style={{marginTop: 3}}
          onClick={saveFirstname}
        >
          {i18n._('Valider')}
        </Button>
      </Grid>
    </Grid>
  );
}
